<template>
  <div class="container">
    <span class="form p-fluid">
      <AutoComplete
        class="p-mx-3 autocomplete"
        v-model="queries"
        :multiple="true"
        :suggestions="filteredTags"
        @complete="search($event)"
        @item-select="req"
        :delay="100"
        placeholder="検索に使用されるタグ"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent,ref } from "vue";
import AutoComplete from "primevue/autocomplete";
import firebase from "../firebase/firebase";

export default defineComponent({
  name: "SetTags",
  components: { AutoComplete },
  setup() {
    return {
      queries: ref([]),
      filteredTags: ref([""]), // 仮
      tags: ref([""]), //
    };
  },
  mounted() {
    this.setFilter();
  },
  methods: {
    setFilter() {
      this.filteredTags = [];
      this.tags = [];
      firebase
        .firestore()
        .collection("misc")
        .doc("tags")
        .get()
        .then((d) => {
          const tmp: any = d.data();
          tmp.tags.forEach((element: string) => {
            this.filteredTags.push(element);
            this.tags.push(element);
          });
        });
    },
    search({ query }: any) {
      if (!query.trim()) {
        this.filteredTags = [...this.tags];
        return;
      }
      // eslint-disable-next-line
      this.filteredTags = this.tags.filter((f: any) => f.includes(query));
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
